import React from "react";
import { motion } from "motion/react";
import { cn } from "../../../lib/utils";
import "./BackgroundGradient.css";

export default function BackgroundGradient({
  children,
  className,
  containerClassName,
  animate = true,
}) {
  const variants = {
    initial: {
      backgroundPosition: "0% 50%",
    },
    animate: {
      backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
    },
  };

  const motionProps = animate
    ? {
        variants,
        initial: "initial",
        animate: "animate",
        transition: {
          duration: 8,
          repeat: Infinity,
          ease: "linear",
        },
        style: { backgroundSize: "400% 400%" },
      }
    : {};

  return (
    <div className={cn("store-bg-gradient-shell", containerClassName)}>
      <div className="store-bg-gradient-blur" />
      <motion.div className="store-bg-gradient-stroke" {...motionProps} />
      <div className={cn("store-bg-gradient-content", className)}>{children}</div>
    </div>
  );
}
